<script setup lang="ts">
/**
 * Star dust fragment glyph — gamification design-system atom (M4C-23 family).
 *
 * The sparkle: a solid upright four-point star layered over a faint, larger
 * star rotated 45° for an eight-point twinkle. Hex-free — colored through a
 * Tailwind token chosen by `tone` (cyan `fragment` by default, red `drift` for
 * fragment-decay rows, M4C-21); sized via the `size` prop.
 */
const props = withDefaults(
  defineProps<{
    /** Rendered width / height in pixels. */
    size?: number;
    /** Colour tone: cyan `fragment` (gains, default) or red `drift` (decay). */
    tone?: 'fragment' | 'drift';
  }>(),
  { size: 28, tone: 'fragment' },
);

const fillClass = computed(() => (props.tone === 'drift' ? 'fill-drift' : 'fill-fragment'));
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 28 28"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Faint backing sparkle: the same star rotated 45° about its centre. -->
    <path
      :class="fillClass"
      opacity="0.3"
      transform="rotate(45 14 14)"
      d="M14 0L17.7813 10.2187L28 14L17.7813 17.7813L14 28L10.2187 17.7813L0 14L10.2187 10.2187L14 0Z"
    />
    <!-- Foreground sparkle with a white separator stroke. -->
    <path
      :class="fillClass"
      stroke="white"
      stroke-width="2.33333"
      d="M16.6875 10.624L16.873 11.127L17.376 11.3125L24.6387 14L17.376 16.6875L16.873 16.873L16.6875 17.376L14 24.6387L11.3125 17.376L11.127 16.873L10.624 16.6875L3.36035 14L10.624 11.3125L11.127 11.127L11.3125 10.624L14 3.36035L16.6875 10.624Z"
    />
  </svg>
</template>
